<template>
    <AuthLayout v-if="!position" :fo_config="fo_config" :settingsConfig="{...settingsConfig, ...{fields: fields} }" :fo_content="fo_content">
        <div>
            <sign-up :config="{...config,...settingsConfig,...paymentConfigs, ...{fields: fields},...getMaxLimits(fieldConfig)}"
                :position="position" :withAuth="false" @sign-in="signup = $event" @submitWithoutAuth="submitClientInfos($event)" 
                @rdv_not_for_me="set_rdv_not_for_me($event)" v-show="!get_client_infos && !user"></sign-up>
        </div>
    </AuthLayout>
    <booking-layout v-else :fo_config="fo_config" :settingsConfig="{...settingsConfig, ...{fields: fields} }" :fo_content="fo_content" :step="current_step" >
        <select-prestation v-if="(current_step == 1)" @submit="go_to_freetimeslot_selection($event)"
                            @mounted="settingsConfig.AUTO_SELECT_PRESTA == 1 && selectFirstPrestation()"
                            :agendas="agendas" :prestations="prestations" :locations="locations" :fo_config="fo_config" :settingsConfig="{...settingsConfig, ...{fields: fields} }">
        </select-prestation>
        <select-time-slot @submit="go_to_confirmation($event)" @back="go_to_prestation_selection()" v-if="(current_step == 2)"
                          :prestations="store.selected_prestations" :locations="locations" :agendas="agendas"
                          :agenda="store.selected_agenda" :location="store.selected_location"
                          :config="{...config,...settingsConfig,...paymentConfigs, ...{fields: fields}}" :fo_config="fo_config"
            >
        </select-time-slot>
        <validate-appointment @submit="submit(prestation)" @back="go_to_freetimeslot_selection(selected_prestations)" @backToFirstStep="go_to_prestation_selection()" v-if="(current_step == 3)"
                          :rdv_data="rdv_data" :prestations="store.selected_prestations" :locations="locations"
                          :agenda="store.selected_agenda" :location="store.selected_location" :rdv_not_for_me="settingsConfig['RDV_FOR_SOMEONE_ELSE'] == 1 && rdv_not_for_me"
                          :config="{...config,...settingsConfig,...paymentConfigs, ...{fields: fields},...fieldConfig}" :fo_config="fo_config" :rdv="rdv" :group_sizes="group_sizes"
            >
        </validate-appointment>
    </booking-layout>
    <!-- <CookieConsent /> -->
</template>

<script>
import BookingLayout from './BookingLayout.vue';
import SelectPrestation from './SelectPrestation.vue';
import SelectTimeSlot from './SelectTimeSlot.vue';
import ValidateAppointment from './ValidateAppointment.vue';
import AuthLayout from '../Auth/AuthLayout.vue';
import SignUp from '../Profile/SignUp.vue';
import { BookingStore } from '../Stores/BookingStore';
import { Utilities } from '../Utilities/utilities';
import { toRaw } from 'vue';
// import CookieConsent from "../SharedComponents/CookiePopUp.vue";

export default {
    name: 'Booking',
    props: ['agendas', 'config', 'locations', 'prestations', 'group_sizes', 'settingsConfig', 'paymentConfigs', 'fo_config', 'price', 'rdv', 'fo_content', 'fields', 'fieldConfig'],
    components: { BookingLayout, SelectPrestation, SelectTimeSlot, ValidateAppointment, AuthLayout, SignUp }, // CookieConsent

    data() {
        return {
            store: BookingStore,
            step: 1,
            rdv_data: null,
            client_infos: null,
            rdv_not_for_me: false,
            configs: null,
        }
    },

    computed: {
        current_step() {
            return BookingStore.current_step;
        },
        position() {
            console.log('BookingStore.user_infos',BookingStore.user_infos);
            
            if(this.settingsConfig['FORM_POSITION'] == 1){
                if(!BookingStore.user_infos) {
                    return false
                }
                return true
            }
            return true
        },
        rdv_not_for_me_computed(){
            return this.rdv_not_for_me;
        },
        display_agendas() {
            if (this.config.force_fo_agenda_selection) return true;

            if (this.config.choose_presta_on_calendar) return true;

            return false;
        },
    },

    methods: {
        init_configs(){
            this.configs = {...this.config,...this.settingsConfig,...this.paymentConfigs, ...{fields: this.fields},...this.fieldConfig};
        },
        getMaxLimits(fieldConfig) {
            let limits = {};
            for (let key in fieldConfig) {
                if (key.startsWith("MAX_LIMITE-")) {
                    limits[key] = fieldConfig[key];
                }
            }
            return limits;
        },
        set_rdv_not_for_me(value){
            this.rdv_not_for_me = value;
        },
        go_to_prestation_selection() {
            if (BookingStore.rdvToModify) return;
            BookingStore.set_step(1);
        },

        go_to_freetimeslot_selection(prestations, update_path = true) {
            this.selected_prestations = prestations;
            BookingStore.set_step(2);
            if (update_path) {
                const presta_ids = BookingStore.selected_prestations.map(p => p.prestation_id);
                const presta_as_params = Utilities.array_to_url_params('prestation_id', presta_ids);
                const agendaAsParams = this.store.selected_agenda ? `agenda_id=${this.store.selected_agenda.agenda_id}&` : ''
                window.history.pushState('', document.title,
                    `/ressources?${agendaAsParams}${presta_as_params}location_id=${BookingStore.selected_location.location_id}&group_size=${BookingStore.get_groupe_size()}`
                );
            }
        },

        selectFirstPrestation(){
            const prestation = this.prestations?.[0];
            // const agenda = prestation?.agendas?.[0];
            // const location = this.locations?.find(l => l.location_id == agenda.location_id);
            if(prestation){
                BookingStore.select_prestations([prestation],null,null);
                this.go_to_freetimeslot_selection(BookingStore.selected_prestations,false);
            }
        },

        go_to_confirmation(rdv_data) {
            this.rdv_data = rdv_data;
            BookingStore.set_step(3);
        },
        applyStyleVars() {
            Object.entries(this.fo_content).forEach(([key, value]) => {
                const cssVarName = `${key.replace(/_/g, '-')}`
                document.documentElement.style.setProperty(cssVarName, value)
                console.log(cssVarName);
                
            })
        },
        select_prestations_from_url(){
            // Récupération paramètres
            let urlParams = Utilities.get_current_url_params();
            urlParams.hasOwnProperty('prestation_id');
            if(!urlParams.hasOwnProperty('prestation_id') || !urlParams.hasOwnProperty('location_id')){
                return;
            }
            
            // Initialisation des objets nécéssaire pour la 1ère étape
            let selected_prestations = [], group_size = 1;
            // taille du groupe
            if(urlParams.hasOwnProperty('group_size') && urlParams['group_size'] > 1){
                group_size = urlParams['group_size'];
            }
            // prestations
            for (const presta of this.prestations) {
                presta.group_size = group_size;
                if(Array.isArray(urlParams['prestation_id'])){
                    if(urlParams['prestation_id'].find(e => e == presta.prestation_id )){
                        selected_prestations.push(toRaw(presta));
                    }
                }else if(presta.prestation_id == urlParams['prestation_id']){
                    selected_prestations.push(toRaw(presta));
                }
            }
            let selected_location = this.locations.find(location => location.location_id == urlParams['location_id']);
            let agenda = null;
            if(urlParams.hasOwnProperty('agenda_id')){
               agenda = this.agendas.find(agenda => agenda.agenda_id == urlParams['agenda_id']);
            }
            if(this.display_agendas && !agenda){
                agenda = this.agendas.find(agenda => agenda.location_id == urlParams['location_id']);
            }
            console.log("Booking select_prestations_from_url prestas",this.prestations,selected_prestations);
            
            // Selection de prestations
            BookingStore.select_prestations(selected_prestations,selected_location,agenda);
        },
        submitClientInfos(client_infos) {
            BookingStore.set_user_infos(client_infos)
            this.client_infos = client_infos
            console.log(BookingStore.user_infos);
            
        },

        select_location_from_url() {
            const urlParams = Utilities.get_current_url_params();
            if (!urlParams.hasOwnProperty('location_id')) return;

            const location = this.locations.find(
                loc => loc.location_id == urlParams['location_id']
            );

            if (!location) return;

            BookingStore.select_location(location);
        },
    },

    beforeMount() {
        if (BookingStore.rdvToModify) {
            this.go_to_freetimeslot_selection(BookingStore.selected_prestations)
        }
    },

 

    mounted() {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // scroll
        // console.log("datas",this.prestations,this.locations,this.agendas);
        // init general configs
        this.init_configs();
        BookingStore.set_configs(this.configs);
        
        // Toujours positionner d'abord à la sélection de prestations si pas une route précise
        this.store.set_step(1);

        // console.log(BookingStore.user_infos);
        this.applyStyleVars()
        
        // Aller à la 2ème étape si paramètres indiqués au niveau de l'url 
        this.select_location_from_url(); 
        this.select_prestations_from_url();
        if(BookingStore.selected_prestations.length > 0 && BookingStore.selected_location){
            const presta_ids = BookingStore.selected_prestations.map(presta => presta.prestation_id);
            // console.log('selectTimeSlot mounted', BookingStore.selected_prestations);
            this.go_to_freetimeslot_selection(BookingStore.selected_prestations,false);
        }

        // Prioritaire Sélectionner la 2ème étape grâce à l'auto select
        if(this.settingsConfig.AUTO_SELECT_PRESTA == 1){
            this.selectFirstPrestation();
        }
        
    },
}

</script>